<template>
  <div class="flex-al-center flex-jc-start">
    <div style="width: auto">
      <div v-if="hireRateDiotType === 'iob'" class="flex-jc-start">
        <div style="width:88px;">
          Invite Owners Best
        </div>
      </div>
      <div v-if="hireRateDiotType === 'dio'" class="flex-jc-start">
        <div style="width: 215px;">
          <SpInput v-model="cargoOrders.hireRateDiot" :height="16" :width="76" type="bottomBorder2" class=""
                   :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px',textIndent: 0 }"
                   :precision="0" text-type="number" :min="0" :max="9999999">
            <template #suffixLeft>
              <span class="sp-color-22" style="width: 40px; display: inline-block">USD</span>
            </template>
          </SpInput>
          <span class="sp-color-22">DIOT(Daily Include Overtime)</span>
        </div>
      </div>
      <div v-if="hireRateDiotType === 'pdDio'" class="flex-jc-start">
        <div style="width: 200px; ">
          <div>
            <SpInput v-model="cargoOrders.hireRateSplit" :height="16" :width="76" type="bottomBorder2" class=""
                     :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px',textIndent: 0 }"
                     :precision="0" text-type="number" :min="0" :max="9999999">
              <template #suffixLeft>
                <span class="sp-color-22" style="width: 40px; display: inline-block">USD</span>
              </template>
            </SpInput>
            <span class="sp-color-22">PD for the 1st</span>
            <SpInput v-model="cargoOrders.hireRateSplitTime" :height="16" :width="36" type="bottomBorder2" class=""
                     :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px',textIndent: 0 }"
                     :precision="0" text-type="number" :min="0" :max="999" /> <span class="sp-color-22">Days</span>
          </div>
          <span class="sp-color-22" style="margin-right: 3px">Thereafter</span>
          <SpInput v-model="cargoOrders.hireRateDiot" :height="16" :width="65" type="bottomBorder2" class=""
                   :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px',textIndent: 0 }"
                   :precision="0" text-type="number" :min="0" :max="9999999">
            <template #suffixLeft>
              <span class="sp-color-22" style="width: 40px; display: inline-block">USD</span>
            </template>
          </SpInput><span class="sp-color-22">DIOT</span>
        </div>
      </div>
    </div>
    <div style="width: 20px">
      <el-popover ref="typePopoverRef"
                  placement="bottom"
                  popper-class="cus-no-pd-popover"
                  :width="382"
                  trigger="click">
        <template #reference>
          <div style="width: 20px;height: 17px; text-align: center">
            <span style="font-size: 6px; position:relative; top: 3px; color:#EEB336;" class="icon-triangle iconfont" />
          </div>
        </template>
        <div class="font10">
          <div class="select-item" :class="{'active-select-item': hireRateDiotType === 'iob'}"
               @click="changeType('iob')">
            Invite Owners Best
          </div>
          <div class="select-item" :class="{'active-select-item': hireRateDiotType === 'dio'}"
               @click="changeType('dio')">
            <div class="input-line" style="width: 76px">USD</div>
            DIOT (Daily Include Overtime)
          </div>
          <div class="select-item"
               :class="{'active-select-item': hireRateDiotType === 'pdDio'}"
               @click="changeType('pdDio')">
            <div class="input-line" style="width: 76px">USD</div>
            PD for the 1st <div class="input-line" style="width: 26px; height: 17px; position: relative; top: 4px;" />
            Days Thereafter <div class="input-line" style="width: 65px;">USD</div>DIOT
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import SpButton from '@/components/common/SpButton'
import SpSelect from '@/components/common/SpSelect.vue'
import SpSelectOption from '@/components/common/SpSelectOption.vue'
import SpInput from '@/components/common/SpInput'

export default {
  name: 'HireRateDiot',
  components: { SpButton, SpInput, SpSelectOption, SpSelect },
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    },

    cargoIndex: {
      type: Number,
      default: null
    },

    isCorrect: {
      type: String,
      default: ''
    },

    defaultType: {
      type: String,
      default: 'iob'
    }
  },

  emits: ['update:modelValue'],
  setup (props, ctx) {
    const typePopoverRef = ref(null)
    const cargoOrders = computed({
      get () {
        return props.modelValue
      },
      set (nv) {
        ctx.emit('update:modelValue', nv)
      }
    })
    const hireRateDiotType = ref('iob')
    watch(() => props.defaultType, () => {
      hireRateDiotType.value = props.defaultType
    })
    const changeType = (type) => {
      hireRateDiotType.value = type
      if (type === 'iob') {
        cargoOrders.value.hire = 'iob'

        cargoOrders.value.hireRateDiot = null

        cargoOrders.value.hireRateSplit = null
        cargoOrders.value.hireRateSplitTime = null
        cargoOrders.value.hireRateDiot = null
      }

      if (type === 'dio') {
        cargoOrders.value.hire = null

        cargoOrders.value.hireRateSplit = null
        cargoOrders.value.hireRateSplitTime = null
        cargoOrders.value.hireRateDiot = null
      }
      if (type === 'pdDio') {
        cargoOrders.value.hire = null

        cargoOrders.value.hireRateDiot = null
      }
      typePopoverRef.value.hide()
    }
    return {
      cargoOrders,
      hireRateDiotType,
      typePopoverRef,
      changeType
    }
  }
}
</script>

<style scoped lang="less">
.zhijian{
  display: inline-block;
  width: 5px;
  border-top: 1px solid #000000;
  height: 3px;
  margin-left: 6px;
  margin-right: 4px;
}
.select-item {
  line-height: 28px;
  padding: 0 10px;
  .icon-triangle {
    position: relative;
    font-size: 8px;
    top: -2px;
  }

  .btn{
    display: inline-block;
    width: 77px;
    text-align: center;
    border-radius: 3px;
    height: 17px;
    line-height: 17px;
    background: #FCD88A;
  }
  cursor: pointer;
  height: 28px;
  &.active-select-item{
    background-color: #F7F7F7;
    color: #3A909D;
    .input-line {
      height: 22px;
      width: 76px;
      border-bottom: 1px solid #3A909D
    }
  }
  .input-line {
    display: inline-block;
    height: 22px;
    width: 76px;
    border-bottom: 1px solid gray
  }
}
.select-item:hover {
  background-color: #F7F7F7;
  cursor: default;
  color: #3A909D;
  .input-line {
    border-bottom: 1px solid #3A909D
  }
}
</style>
